module.exports = __webpack_public_path__ + "static/media/Banner_final.e7437836.jpg";